import { connect } from 'react-redux';
import EditEntity from '../components/EntityEditing/EditEntity';

const mapStateToProps = state => ({
  loadingOverwrites: state.stadiumOverwrites.loading,
  writing: state.stadiumOverwrites.writing,
  overwrites: state.stadiumOverwrites.overwrites,
  writeError: state.stadiumOverwrites.writeError,
  fetchOverwriteError: state.stadiumOverwrites.error,
  currentEdits: state.edits.currentEdits,
  editsDirty: state.edits.dirty,
});

export default connect(mapStateToProps)(EditEntity);
